export default function ArmoMail(
   cliente,
   fields,
   provisions,
   ynState,
   imagePreview
) {
   console.log("ArmoMail 1: ", ynState[1]);
   console.log('imagePreview: ', imagePreview);
   return `
         <div>
            <h3>Datos del cliente</h3>
            <table style={{ border: "1px solid black", width: "40%" }}>
               <tbody>
                  <tr>
                     <td >Cliente:</td>
                     <td>
                        ${cliente[1]} Documento: (${cliente[0]})
                     </td>
                  </tr>
                  <tr>
                     <td >Email:</td>
                     <td>${cliente[4]}</td>
                  </tr>
                  <tr>
                     <td >Telefono:</td>
                     <td>${cliente[3]}</td>
                  </tr>
                  <tr>
                     <td >Dirección:</td>
                     <td>${cliente[2]}</td>
                  </tr>
                  <tr>
                     <td >Fecha de nacimiento:</td>
                     <td>${cliente[8]}</td>
                  </tr>
               </tbody>
            </table>
          </div>
          <div>
            <h3>Datos del Piercing</h3>
            <table style={{ border: "1px solid black", width: "40%" }}>
               <tbody>
                  <tr>
                     <td >Zona del cuerpo:</td>
                     <td>${fields[0]}</td>
                  </tr>
                  <tr>
                     <td >Tipo Joyería:</td>
                     <td>${fields[1]}</td>
                  </tr>
                  <tr>
                     <td >Medida especifica:</td>
                     <td>${fields[2]}</td>
                  </tr>
                  <tr>
                     <td >Tipo de accesorio:</td>
                     <td>${fields[3]}</td>
                  </tr>
                  <tr>
                     <td >Material:</td>
                     <td>${fields[4]}</td>
                  </tr>
                  <tr>
                     <td >Tiempo minimo de cicatrización:</td>
                     <td>${fields[5]}</td>
                  </tr>
                  <tr>
                     <td >Valor de trabajo:</td>
                     <td>${fields[6]}</td>
                  </tr>
               </tbody>

            </table>

          </div>
      <div>
        <h3>Conformidad</h3>
        <table>
          <tr><td>Conformidad : ${
             ynState[0] === "y"
                ? `Acepto:  ${provisions[0]}`
                : `No Acepto : ${provisions[0]}`
          }</td></tr>
          <tr><td>Embarazo : ${
             String(ynState[1]).toLowerCase().trim() === "y"
                ? `Si ${provisions[1]}`
                : "No"
          }</td></tr>
          <tr><td>Alimentación : ${
             ynState[2] === "y"
                ? `He Comido en las ultimas 4 horas.  ${provisions[2]} `
                : "No"
          }</td></tr>
          <tr><td>Antecedentes de salud : ${
             ynState[3] === "y" ? `Si  ${provisions[3]}` : "No"
          }</td></tr>
          <tr><td>Tratamientos : ${
             ynState[4] === "y" ? `Si  ${provisions[4]}` : "No"
          }</td></tr>
          <tr><td>Anticoagulantes : ${
             ynState[5] === "y" ? `Si  ${provisions[5]}` : "No"
          }</td></tr>
          <tr><td>Tabaco y drogas : ${
             ynState[6] === "y" ? `Si  ${provisions[6]}` : "No"
          }</td></tr>
          <tr><td>Alergias : ${
             ynState[7] === "y" ? `Si  ${provisions[7]}` : "No"
          }</td></tr>
          <tr><td>Fotografía : ${
             ynState[8] === "y"
                ? `SI Libero todos los derechos sobre cualquier fotografía  ${provisions[8]}`
                : "No Libero"
          }</td></tr>
          </table>
          </div>
          `;
          //  ${imagePreview.map(
          //       (img, index) =>(
          //           `<tr>
          //            <td>Imagen ${index + 1}: 
          //            <img src="${img.data}" alt="Imagen subida ${index + 1}" />
          //            </td>
          //            </tr>`
          //     )).join("")}
}
